// eslint-disable-next-line import/no-unresolved
import Swiper from 'swiper/bundle';

const swipers = [];

document.querySelectorAll('.swiper-headline-carousel')?.forEach(
  (slider) => {
    swipers.push(new Swiper(slider, JSON.parse(slider.getAttribute('data-slider-settings'))));
  },
);

// eslint-disable-next-line no-console
// console.log(`Initialised ${swipers.length} headline carousel swipers`, swipers);
